import { Container } from '@/platform/ui';
import PagePlaceholder from './components/PagePlaceholder';
import QuestionnairePanel from './components/QuestionnairePanel';

const QuestionnaireShowView = () => (
    <Container fluid>
        <PagePlaceholder />

        <QuestionnairePanel />
    </Container>
);

export default QuestionnaireShowView;
